
export default {
  data() {
    return {
      accountInfo: {},
      memberPointsAvailable: 0,
      memberPointEquivalent: 0
    }
  },
  computed: {
    isYuuMember() {
      return this.accountInfo?.yuuId
    }
  },
  mounted() {
    const { isOnline } = this.$utils.getLoginStatus()
    if (isOnline) {
      const accountInfo = localStorage.getItem("accountInfo")
        ? this.$utils.base64Decode(localStorage.getItem("accountInfo"))
        : {}
      this.accountInfo = accountInfo
      if (this.accountInfo && this.accountInfo.pointVo) {
        this.memberPointsAvailable = this.accountInfo.pointVo.memberPointsAvailable.toLocaleString()
        this.memberPointEquivalent = this.accountInfo.pointVo.memberPointEquivalent.toLocaleString()
      }
    }
  },
  methods: {
    handleClickContinue() {
      this.$emit("clickContinue")
    }
  }
}
